import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

const CambiarPassword = ({ usuario, onLogout, onPasswordChanged, forzado }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ password_actual: '', password_nueva: '', confirmar: '' });
  const [show, setShow] = useState({ actual: false, nueva: false, confirmar: false });
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [saving, setSaving] = useState(false);

  const guardar = async (e) => {
    e.preventDefault();
    setError(''); setOk('');

    if (form.password_nueva.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres');
      return;
    }
    if (form.password_nueva !== form.confirmar) {
      setError('Las contraseñas nuevas no coinciden');
      return;
    }

    setSaving(true);
    try {
      await api.put('/usuarios/mi-password', {
        password_actual: form.password_actual,
        password_nueva: form.password_nueva,
      });
      setOk('Contraseña actualizada correctamente');
      setForm({ password_actual: '', password_nueva: '', confirmar: '' });
      // Actualizar el usuario para quitar el flag debe_cambiar_password
      if (onPasswordChanged && usuario) {
        onPasswordChanged({ ...usuario, debe_cambiar_password: false });
      }
      setTimeout(() => navigate('/'), 1500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cambiar la contraseña');
    } finally {
      setSaving(false);
    }
  };

  const campoPassword = (label, campo, key) => (
    <div style={S.group}>
      <label style={S.label}>{label}</label>
      <div style={{ position: 'relative' }}>
        <input
          style={{ ...S.input, paddingRight: '44px', width: '100%', boxSizing: 'border-box' }}
          type={show[key] ? 'text' : 'password'}
          value={form[campo]}
          onChange={e => setForm({ ...form, [campo]: e.target.value })}
          placeholder={label}
          required
        />
        <button type="button" onClick={() => setShow({ ...show, [key]: !show[key] })}
          style={S.eye} tabIndex={-1} aria-label={show[key] ? 'Ocultar' : 'Mostrar'}>
          {show[key] ? '🙈' : '👁️'}
        </button>
      </div>
    </div>
  );

  return (
    <Layout usuario={usuario} onLogout={onLogout} title="Cambiar Contraseña">
      <div style={S.card}>
        {forzado && (
          <div style={S.aviso}>
            🔒 Por seguridad, debes cambiar tu contraseña temporal antes de usar la aplicación.
          </div>
        )}
        {error && <div style={S.error}>{error}</div>}
        {ok && <div style={S.ok}>{ok}</div>}
        <form onSubmit={guardar} style={S.form}>
          {campoPassword('Contraseña actual', 'password_actual', 'actual')}
          {campoPassword('Nueva contraseña', 'password_nueva', 'nueva')}
          {campoPassword('Confirmar nueva contraseña', 'confirmar', 'confirmar')}
          <div style={S.hint}>Mínimo 6 caracteres.</div>
          <div style={S.btns}>
            {!forzado && (
              <button type="button" style={S.btnCancel} onClick={() => navigate('/')}>Cancelar</button>
            )}
            <button type="submit" style={S.btnSave} disabled={saving}>
              {saving ? 'Guardando...' : 'Cambiar contraseña'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

const S = {
  card: { background: '#fff', borderRadius: '12px', padding: '24px', maxWidth: '460px', margin: '0 auto', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  group: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#555' },
  input: { padding: '10px 12px', borderRadius: '7px', border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none', color: '#1a1a1a' },
  eye: { position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', padding: 0, lineHeight: 1 },
  hint: { fontSize: '11px', color: '#999', fontStyle: 'italic' },
  aviso: { background: '#fff8e1', border: '1px solid #ffe082', color: '#8a6d3b', padding: '12px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', fontWeight: '600' },
  error: { background: '#fff0f0', border: '1px solid #ffcccc', color: '#CC0000', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  ok: { background: '#f0fff4', border: '1px solid #c6f6d5', color: '#22543d', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  btns: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '8px' },
  btnCancel: { padding: '10px 20px', borderRadius: '7px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  btnSave: { padding: '10px 20px', borderRadius: '7px', border: 'none', background: '#CC0000', color: '#fff', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
};

export default CambiarPassword;
